// extracted by css-extract-rspack-plugin
export default {"ImageCard":"UpsellCardContent-module__ImageCard___Ath6d","UpsellCta":"UpsellCardContent-module__UpsellCta___yOUa3"};